/* ============================================================================
   ENGORI — Cookie-Banner.

   Herkunft: Baustein `baustein-cookie-banner` aus dem MBL-Baukasten
   (dort `mx-cookie.js`, geerntet aus Dream-Ass). Portiert am 01.10.2026.
   Geaendert wurden nur die Namen (`mx-` -> `engori-`, `data-mx-cc-*` ->
   `data-eng-cc-*`, Speicherschluessel `da_consent` -> `engori_consent`,
   Ereignis `da:consent` -> `engori:consent`, `window.daCookies` ->
   `window.engoriCookies`) und EIN zusaetzlicher Oeffner-Selektor, siehe
   dort. Die Logik ist unveraendert.

   Meldet die Auswahl des Besuchers an Shopifys Customer Privacy API und merkt
   sie sich lokal. Markup: `snippets/engori-cookie-banner.liquid`.
   Gestaltung: `assets/engori-cookie.css`.

   ⚠ Diese Datei wird als Sourcemap oeffentlich mit ausgeliefert
   (`engori-cookie.js.map`, HTTP 200, `sourcesContent` enthaelt den Volltext).
   Jeder Kommentar hier ist damit oeffentlich lesbar und im Streitfall
   zitierbar. Es steht deshalb nichts darin, was eine Absicht beschreibt —
   nur, was gebaut ist und warum es technisch so sein muss.

   ⚠ WARUM ZWEI SPEICHER — API UND localStorage.
   Die API haelt den Zustand fuer Shopify (Pixel, Analytics, Kasse). Der
   localStorage entscheidet allein darueber, OB der Banner noch erscheint. Die
   Trennung ist kein Umweg: Shopifys Feature-Loader wird von verbreiteten
   Inhaltsblockern geblockt. Haenge man die Sichtbarkeit an
   `shouldShowBanner()`, erschiene bei genau diesen Besuchern nie ein Banner —
   und damit wuerde nie eine Einwilligung eingeholt.

   ⚠ WARUM DER BANNER IMMER ERSCHEINT, wenn keine Auswahl vorliegt, statt nur
   in Einwilligungsregionen. `shouldShowBanner()` haengt an einer
   Admin-Einstellung und an einer API, die geblockt sein kann. Zu viel fragen
   ist zulaessig, zu wenig fragen nicht. Der Shop liefert nach DE, AT und CH.

   ⚠ WAS DIESER BANNER NICHT STEUERT: alles, was von Hand ins Theme gelegt
   wird — ein Google-Tag-Manager im Layout, ein Meta-Pixel in einem Snippet,
   ein eingebettetes Video. Gemessen am 01.10.2026 gibt es davon im
   ENGORI-Theme nichts (kein fbq, kein gtag, kein GTM in layout, snippets,
   sections, templates, config). Meta-Pixel und Meta CAPI laufen ueber
   Shopifys Web-Pixel-Anbindung und haengen damit an der API. Kommt etwas hinzu, muss es an
   `Shopify.customerPrivacy.analyticsProcessingAllowed()` gehaengt werden —
   das ist der verlaessliche Anschluss, nicht das Ereignis unten.
   ============================================================================ */
(function () {
  'use strict';

  var SCHLUESSEL = 'engori_consent';
  var FORMAT = 1; // Aufbau des Datensatzes. Aendert sich der Aufbau, wird neu gefragt.
  // ⚠ Hochsetzen, wenn sich Kategorien oder die genannten Zwecke im Snippet
  // aendern — sonst gilt eine Einwilligung weiter, die einem anderen Text galt.
  // 2 seit 19.08.2026: "Anonyme Messung" war unzutreffend, Shopify-Analytics
  // arbeitet mit einer Besucherkennung. Zweck neu formuliert, Speicherdauer
  // ergaenzt.
  // 3 seit 19.08.2026: Einleitungstext gekuerzt, Speicherdauer und
  // Ex-nunc-Hinweis in die zweite Ebene verschoben.
  var TEXTVERSION = 3;
  var GUELTIG_TAGE = 365;
  var AUS_MS = 260; // muss zu --engori-cc-t in `engori-cookie.css` passen
  var API_TIMEOUT_MS = 3000;

  var wurzel = document.querySelector('[data-eng-cc]');
  if (!wurzel) return;

  var panel = wurzel.querySelector('.engori-cc__panel');
  var panelOffen = false;
  var ausTimer = null;
  var letzterAusloeser = null;
  var api = null;
  var apiGeprueft = false;
  // Laufnummer je Auswahl. Ohne sie gewinnt bei zwei schnell aufeinander
  // folgenden Klicks die AELTERE Antwort das Rennen um den Speicher, waehrend
  // die API die neuere haelt — und beim naechsten Seitenaufruf wuerde der
  // Speicherstand die widerrufene Einwilligung wiederherstellen. Gemessen am
  // 19.08.2026 mit 60 ms Abstand zwischen "Alle akzeptieren" und "Alle
  // ablehnen": Endzustand API {nein}, Speicher {ja}.
  var lauf = 0;

  var FELDER = ['analytics', 'marketing', 'preferences'];

  /* ---- Betriebsart ------------------------------------------------------
     Festgelegt von Werner am 31.10.2026, woertlich: "behandel als wenn kei
     banner da ist aber trotzdem anzeigen lassen, nur ohne funktion".

     'steuernd'  Die Auswahl des Besuchers bestimmt, was geladen wird.
                 Das war der Stand bis zum 31.10.2026.
     'anzeige'   Die Karte wird gezeigt und laesst sich wegklicken, steuert
                 aber nichts. Die Messdienste laufen vom ersten Moment an,
                 unabhaengig von jeder Auswahl. AKTIV.

     ⚠ Zum Zurueckschalten genuegt es, den Wert in der naechsten Zeile auf
     'steuernd' zu setzen. Nichts anderes ist anzufassen, der vollstaendige
     bisherige Ablauf steht unveraendert darunter. Die Fassung vom 31.10.2026
     vor der Umstellung liegt als `engori-cookie.js.vor-anzeigemodus-2026-10-31`
     im selben Ordner.

     Hintergrund und Messwerte stehen NICHT hier, sondern im Gehirn:
     `02_Shops/Engori/MESSWERTE-Warenkorb-Cookiebanner-2026-10-31.md`.
     Diese Datei wird oeffentlich ausgeliefert. */
  var BETRIEBSART = 'anzeige';

  function vollerStand() {
    return { analytics: true, marketing: true, preferences: true };
  }

  /* ---- Speicher ---------------------------------------------------------- */
  // Alles in try/catch: im privaten Modus mancher Browser wirft schon der
  // Zugriff auf localStorage. Eine Ausnahme hier legte den ganzen Banner still.
  function lesen() {
    try {
      var roh = window.localStorage.getItem(SCHLUESSEL);
      if (!roh) return null;
      var satz = JSON.parse(roh);
      if (!satz || satz.v !== FORMAT || satz.tv !== TEXTVERSION) return null;
      // ⚠ `c` muss geprueft werden, nicht nur die Version. Ein Datensatz ohne
      // `c` galt sonst als gueltig: der Banner blieb weg UND das Senden warf
      // eine Ausnahme — kein Banner, keine Einwilligung, keine Moeglichkeit
      // mehr, gefragt zu werden. Gemessen am 19.08.2026.
      if (!satz.c || typeof satz.c !== 'object') return null;
      var alter = Date.now() - Date.parse(satz.t);
      // `alter < 0` faengt eine falsch gestellte Geraeteuhr ab. Ohne diese
      // Schranke laeuft eine Einwilligung mit Zeitstempel in der Zukunft nie
      // ab und die Jahresfrist greift faktisch nicht.
      if (!isFinite(alter) || alter < 0 || alter > GUELTIG_TAGE * 86400000) return null;
      return satz;
    } catch (e) {
      return null;
    }
  }

  function schreiben(auswahl, gemeldet) {
    try {
      window.localStorage.setItem(
        SCHLUESSEL,
        JSON.stringify({
          v: FORMAT,
          tv: TEXTVERSION,
          t: new Date().toISOString(),
          id: api && typeof api.consentId === 'function' ? api.consentId() : null,
          sync: !!gemeldet,
          c: auswahl
        })
      );
    } catch (e) {
      /* Kein Speicher — die Auswahl gilt dann nur fuer diese Sitzung. */
    }
  }

  /* ---- Shopify Customer Privacy API -------------------------------------- */
  function mitApi(weiter) {
    if (api) return weiter(api);
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      return weiter(null);
    }
    // Der Rueckruf von loadFeatures kommt in manchen Faellen spaet oder gar
    // nicht (Blocker, langsame Verbindung). Der Wecker beendet das Warten —
    // er darf aber nicht die ganze Seitensitzung verriegeln.
    var beantwortet = false;
    var wecker = window.setTimeout(function () {
      if (beantwortet) return;
      beantwortet = true;
      weiter(null);
    }, API_TIMEOUT_MS);

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fehler) {
      window.clearTimeout(wecker);
      // ⚠ Die Zuweisung steht VOR der Abbruchpruefung. Kommt die Antwort erst
      // nach dem Wecker, war `api` sonst fuer immer null: auch ein zweiter
      // Klick ueber den Fusszeilen-Link haette Shopify dann nicht mehr
      // erreicht, obwohl die API laengst da war. Gemessen am 19.08.2026 mit
      // kuenstlich verzoegertem loadFeatures.
      api = fehler ? null : window.Shopify.customerPrivacy || null;
      apiGeprueft = true;
      if (beantwortet) return;
      beantwortet = true;
      weiter(api);
    });
  }

  // ⚠ Die Meldungen an Shopify werden NACHEINANDER geschickt, nie parallel.
  // Zwei gleichzeitige `setTrackingConsent`-Aufrufe koennen sich auf dem Weg
  // ueberholen: gemessen am 19.08.2026 blieb nach "Alle akzeptieren" gefolgt
  // von "Alle ablehnen" im Speicher die Ablehnung stehen, bei Shopify aber die
  // Zustimmung. Der Speicher allein reicht also nicht — auch die API muss den
  // zuletzt gewaehlten Stand halten, sonst laeuft Tracking, das der Besucher
  // abgelehnt hat.
  //
  // Verfahren: `gewuenscht` haelt immer den zuletzt gewaehlten Stand. Laeuft
  // schon eine Meldung, wird nur `gewuenscht` aktualisiert; der laufende
  // Vorgang sieht am Ende, dass sich etwas geaendert hat, und schickt erneut.
  var gewuenscht = null;
  var sendetGerade = false;
  var offeneRueckrufe = [];

  function senden(auswahl, danach) {
    gewuenscht = auswahl;
    if (danach) offeneRueckrufe.push(danach);
    if (sendetGerade) return;
    sendetGerade = true;
    losSenden();
  }

  function fertig(ok) {
    sendetGerade = false;
    var liste = offeneRueckrufe;
    offeneRueckrufe = [];
    liste.forEach(function (f) { f(ok); });
  }

  function losSenden() {
    var stand = gewuenscht;
    mitApi(function (a) {
      if (!a || typeof a.setTrackingConsent !== 'function') return fertig(false);
      a.setTrackingConsent(
        {
          analytics: !!stand.analytics,
          marketing: !!stand.marketing,
          preferences: !!stand.preferences,
          // `sale_of_data` stammt aus dem US-Recht (CCPA/CPRA) und hat im
          // deutschen Banner keine eigene Zeile — ein Schalter "Verkauf
          // personenbezogener Daten" waere fuer die Zielgruppe unverstaendlich.
          // Er wird an Marketing gekoppelt: wer Werbung ablehnt, lehnt auch
          // die Weitergabe zu Werbezwecken ab.
          sale_of_data: !!stand.marketing
        },
        function (ergebnis) {
          var ok = !(ergebnis && ergebnis.error);
          // Inzwischen neu gewaehlt? Dann gilt das Neue, nicht das Gemeldete.
          if (gewuenscht !== stand) return losSenden();
          fertig(ok);
        }
      );
    });
  }

  /* ---- Sichtbarkeit ------------------------------------------------------ */
  function zeigen() {
    // Ein laufendes Ausblenden abbrechen. Ohne das versteckt dessen Timeout den
    // gerade wieder geoeffneten Banner — zu sehen, wenn jemand direkt nach dem
    // Speichern den Fusszeilen-Link antippt.
    if (ausTimer) {
      window.clearTimeout(ausTimer);
      ausTimer = null;
    }
    wurzel.hidden = false;
    void wurzel.offsetWidth; // Reflow, sonst greift der Zustandswechsel ohne Uebergang
    wurzel.setAttribute('data-state', 'ein');
  }

  function verbergen() {
    // `data-state="aus"` blendet nicht nur aus, es nimmt in `engori-cookie.css` auch
    // `pointer-events`. Ohne das blieb die Karte 260 ms lang unsichtbar, aber
    // voll treffbar — auf dem Handy ueber der halben Bildschirmflaeche.
    wurzel.setAttribute('data-state', 'aus');
    if (ausTimer) window.clearTimeout(ausTimer);
    ausTimer = window.setTimeout(function () {
      ausTimer = null;
      wurzel.hidden = true;
      panelSetzen(false);
      // Fokus zurueck an den Ausloeser, sonst steht er im Nichts.
      if (letzterAusloeser && document.contains(letzterAusloeser)) {
        try { letzterAusloeser.focus(); } catch (e) {}
        letzterAusloeser = null;
      }
    }, AUS_MS);
  }

  function panelSetzen(offen) {
    panelOffen = offen;
    wurzel.setAttribute('data-panel', offen ? 'open' : 'closed');
    var knopf = wurzel.querySelector('[data-eng-cc-aktion="panel"]');
    if (knopf) knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');

    // ⚠ Das zugeklappte Panel ist nur optisch weg. Die Hoehenanimation ueber
    // grid-template-rows 0fr klippt den Inhalt, nimmt ihn aber nicht aus dem
    // Fokusbaum: gemessen am 19.08.2026 tabbte man nach "Einstellungen" durch
    // drei unsichtbare Schalter und konnte "Auswahl speichern" blind
    // ausloesen — eine Einwilligung, deren Kategorien niemand gesehen hat.
    // `inert` nimmt Fokus und Vorlesebaum in einem; wo es fehlt, greift
    // zusaetzlich `visibility: hidden` aus `engori-cookie.css`.
    if (panel) {
      if (offen) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    }

    // ⚠ Mit offenen Einstellungen ist die Karte auf kleinen Geraeten hoeher
    // als der Bildschirm. Sie scrollt dann in sich selbst, und "Auswahl
    // speichern" stand 122 px unterhalb des Sichtbereichs — wer das nicht
    // ahnt, kommt nur ueber Alles oder Nichts heraus. Verzoegert, weil die
    // Hoehenanimation erst laufen muss.
    if (!offen) return;
    window.setTimeout(function () {
      var speichern = wurzel.querySelector('[data-eng-cc-aktion="speichern"]');
      if (!speichern || wurzel.hidden) return;
      var r = speichern.getBoundingClientRect();
      if (r.bottom <= window.innerHeight && r.top >= 0) return;
      try {
        speichern.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } catch (e) {
        speichern.scrollIntoView(false);
      }
    }, 320);
  }

  /* ---- Schalter ---------------------------------------------------------- */
  function ausSchaltern() {
    var a = {};
    FELDER.forEach(function (f) {
      var e = wurzel.querySelector('#engori-cc-' + f);
      a[f] = !!(e && e.checked);
    });
    return a;
  }

  function inSchalter(auswahl) {
    FELDER.forEach(function (f) {
      var e = wurzel.querySelector('#engori-cc-' + f);
      if (e) e.checked = !!(auswahl && auswahl[f]);
    });
  }

  function melden(auswahl, quelle) {
    document.dispatchEvent(new CustomEvent('engori:consent', { detail: { auswahl: auswahl, quelle: quelle } }));
  }

  /* ---- Auswahl anwenden -------------------------------------------------- */
  function anwenden(auswahl) {
    // In der Betriebsart 'anzeige' wird die Auswahl nicht ausgewertet: der
    // Stand bleibt derselbe, den der Startblock bereits gesetzt hat. Die
    // Knoepfe schliessen die Karte, mehr tun sie nicht.
    if (BETRIEBSART === 'anzeige') auswahl = vollerStand();
    var meine = ++lauf;
    // Erst schliessen, dann melden: die Antwort der API kann ausbleiben, und
    // eine Karte, die nach dem Klick stehen bleibt, wird als Fehler gelesen
    // und weggeklickt. Bleibt die Meldung aus, steht `sync: false` im
    // Datensatz und der naechste Seitenaufruf sendet erneut.
    verbergen();
    schreiben(auswahl, false);
    senden(auswahl, function (ok) {
      // Nur die juengste Auswahl darf schreiben — sonst ueberholt eine alte
      // Antwort die neue.
      if (ok && meine === lauf) schreiben(auswahl, true);
    });
    melden(auswahl, 'auswahl');
  }

  /* ---- Bedienung --------------------------------------------------------- */
  // `e.target` ist bei synthetischen Ereignissen nicht zwingend ein Element.
  // Ohne diese Pruefung warf der Handler bei jedem `dispatchEvent` auf
  // document — gemessen am 19.08.2026: "e.target.closest is not a function".
  function ausloeser(e, wahl) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return null;
    return t.closest(wahl);
  }

  wurzel.addEventListener('click', function (e) {
    var ziel = ausloeser(e, '[data-eng-cc-aktion]');
    if (!ziel) return;
    switch (ziel.getAttribute('data-eng-cc-aktion')) {
      case 'alle':
        anwenden({ analytics: true, marketing: true, preferences: true });
        break;
      case 'keine':
        anwenden({ analytics: false, marketing: false, preferences: false });
        break;
      case 'speichern':
        anwenden(ausSchaltern());
        break;
      case 'panel':
        panelSetzen(!panelOffen);
        break;
    }
  });

  // ESC schliesst NUR das Panel. Den Banner schliesst es nie: keine Auswahl
  // ist keine Zustimmung.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panelOffen && !wurzel.hidden) panelSetzen(false);
  });

  // Wiedereroeffnen ueber den Fusszeilen-Link (oder jeden anderen Ausloeser).
  // ⚠ ENGORI-Zusatz 01.10.2026: zusaetzlich zur Datenattribut-Marke wird
  // `a[href$="#cookie-einstellungen"]` bedient. Ein Eintrag im Shopify-Menue
  // kann kein Datenattribut tragen, nur eine Sprungmarke — und der
  // Vorgaenger-Dialog (`assets/engori-cookie-banner.js`, bis 01.10.2026 im
  // Theme) hat genau auf diese Marke gehoert. Ohne den Selektor waere ein
  // vorhandener Menueintrag ein toter Widerrufsweg.
  document.addEventListener('click', function (e) {
    var knopf = ausloeser(e, '[data-eng-cc-oeffnen], a[href$="#cookie-einstellungen"], [data-cookie-einstellungen]');
    if (!knopf) return;
    e.preventDefault();
    letzterAusloeser = knopf;
    var satz = lesen();
    inSchalter(satz ? satz.c : null);
    zeigen();
    panelSetzen(true);
    var erster = wurzel.querySelector('[data-eng-cc-aktion="alle"]');
    if (erster) { try { erster.focus(); } catch (err) {} }
  });

  /* ---- Kleine Schnittstelle fuer spaeteren Code -------------------------- */
  window.engoriCookies = {
    stand: function () {
      var s = lesen();
      return s ? s.c : null;
    },
    oeffnen: function () {
      var s = lesen();
      inSchalter(s ? s.c : null);
      zeigen();
      panelSetzen(true);
    }
  };

  /* ---- Start ------------------------------------------------------------- */
  panelSetzen(false); // setzt `inert` auf das zugeklappte Panel

  var gespeichert = lesen();

  if (BETRIEBSART === 'anzeige') {
    // Sofort freigeben, ohne auf eine Auswahl zu warten.
    senden(vollerStand(), function (ok) {
      if (ok) schreiben(vollerStand(), true);
    });
    melden(vollerStand(), gespeichert ? 'gespeichert' : 'anzeige');
    inSchalter(vollerStand());
    // Wer schon einmal geklickt hat, sieht die Karte 365 Tage nicht wieder.
    if (gespeichert) return;
    if (window.Shopify && window.Shopify.designMode) return;
    zeigen();
    return;
  }

  if (gespeichert) {
    inSchalter(gespeichert.c);
    // Auch bei vorhandener Auswahl erneut melden: eine beim letzten Mal
    // gescheiterte Meldung (`sync: false`) holt sich hier nach.
    var meine = ++lauf;
    senden(gespeichert.c, function (ok) {
      if (ok && !gespeichert.sync && meine === lauf) schreiben(gespeichert.c, true);
    });
    // ⚠ Auch beim Wiederbesuch melden. Vorher feuerte das Ereignis nur nach
    // einem Klick — fuer jeden Wiederkehrer also nie, und damit fuer die
    // Mehrzahl aller Seitenaufrufe. Wer daran haengt, laedt sonst nicht.
    melden(gespeichert.c, 'gespeichert');
    return;
  }

  // Im Theme-Editor nicht von selbst aufpoppen — er verdeckte sonst die Vorschau.
  if (window.Shopify && window.Shopify.designMode) return;

  zeigen();
})();
